
import { createRoot } from 'react-dom/client'
import { LazyMotion, domAnimation } from 'framer-motion'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { initializeAnalytics, trackCoreWebVitals } from './lib/analytics.ts'
import { bootstrapServices, healthCheck } from './shared/infrastructure/bootstrap'

// Initialize services BEFORE anything else
try {
  console.log('🚀 Initializing services...');
  bootstrapServices();
  
  // Verify all services are healthy
  const health = healthCheck();
  if (health.status === 'unhealthy') {
    console.error('❌ Service health check failed:', health.services);
  } else {
    console.log('✅ All services initialized successfully');
  }
} catch (error) {
  console.error('❌ Failed to initialize services:', error);
}

// Initialize Google Analytics in production
if (import.meta.env.PROD) {
  // Initialize with your Google Analytics measurement ID
  initializeAnalytics('G-XXXXXXXXXX'); // Replace with your actual measurement ID
  
  // Monitor Core Web Vitals
  trackCoreWebVitals();
  
  console.log('Production build initialized with analytics');
}

// Prefetch common navigation routes for better performance
const prefetchLinks = [
  '/login',
  '/cadastro',
  '/personalidade',
  '/termos',
  '/privacidade'
];

// Helper to prefetch routes
const prefetchRoute = (path: string) => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = path;
  document.head.appendChild(link);
};

// Prefetch after the page loads
window.addEventListener('load', () => {
  // Delay prefetching to not interfere with initial render
  setTimeout(() => {
    prefetchLinks.forEach(prefetchRoute);
  }, 2000);
});

// Start the React application
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <LazyMotion features={domAnimation}>
      <App />
    </LazyMotion>
  </HelmetProvider>
);
